// Rebuy Quick View: size the results dropdown to the remaining viewport.
// --rebuy-qv-offset      = announcement bar          (container height)
// --rebuy-qv-offset-full = announcement bar + search (mobile overlay height)
// CSS keeps the 100dvh so Safari's collapsing address bar is still handled
// reactively via dvh.
(function () {
  const OFFSET_VAR = '--rebuy-qv-offset';
  const OFFSET_FULL_VAR = '--rebuy-qv-offset-full';
  const MODAL_ID = 'rebuy-quick-view-dropdown-search';
  const INPUT_SEL = '.rebuy-quick-view-dropdown__input-container';
  const ANNOUNCEMENT_SEL = '.announcement-bar';

  let resizeObserver = null;

  function updateOffset() {
    const modal = document.getElementById(MODAL_ID);
    if (!modal) return;

    const announcement = document.querySelector(ANNOUNCEMENT_SEL);
    const inputContainer = modal.querySelector(INPUT_SEL) || document.querySelector(INPUT_SEL);

    const announcementH = announcement ? announcement.offsetHeight : 0;
    const inputH = inputContainer ? inputContainer.offsetHeight : 0;

    document.documentElement.style.setProperty(OFFSET_VAR, `${announcementH}px`);
    document.documentElement.style.setProperty(OFFSET_FULL_VAR, `${announcementH + inputH}px`);
  }

  function watchSizes() {
    if (typeof ResizeObserver === 'undefined') return;
    if (resizeObserver) resizeObserver.disconnect();

    resizeObserver = new ResizeObserver(updateOffset);

    const announcement = document.querySelector(ANNOUNCEMENT_SEL);
    const inputContainer = document.querySelector(INPUT_SEL);
    if (announcement) resizeObserver.observe(announcement);
    if (inputContainer) resizeObserver.observe(inputContainer);
  }

  function refresh() {
    updateOffset();
    watchSizes();
  }

  // Recompute when the modal is added/removed (open/close) and on load/resize.
  const modalObserver = new MutationObserver(function () {
    if (document.getElementById(MODAL_ID)) refresh();
  });
  modalObserver.observe(document.body, { childList: true, subtree: true });

  window.addEventListener('resize', updateOffset);
  window.addEventListener('orientationchange', updateOffset);
  window.addEventListener('load', refresh);

  if (document.readyState !== 'loading') {
    refresh();
  } else {
    document.addEventListener('DOMContentLoaded', refresh);
  }
})();
